<template>
    <div>
      <div class="d-flex justify-content-end mb-2">
        <b-button
            variant="success"
            class="mr-2"
            @click="onlinePayment"
            v-if="showMakePaymentButton"
        >
          {{ $t('make_payment') }}
        </b-button>

        <b-button
            variant="primary"
            class="mr-2"
            @click="$router.push('/document/request/form')"
        >
          {{ $t('new_request') }}
        </b-button>
      </div>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="documentRequest"
            :fields="documentRequestsFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown">
        </b-table>
    </div>
</template>
<script>
import DocumentRequestService from "@/services/DocumentRequestService";
import qs from "qs";
import CustomerService from "@/services/CustomerService";
import Base from "@/plugins/Base";
export default {
    name: "DocumentRequest",
    props:{
      filter:{
          type:Object
      }
    },
    data(){
        return {
            documentRequest: [],
            documentRequestsFields: [
                {
                    key: 'document_type_name',
                    label: this.$t('document_type').toUpper(),
                },
                {
                    key: 'price',
                    label: this.$t('price').toUpper(),
                },
                {
                    key: 'date',
                    label: this.$t('date').toUpper(),
                },
                {
                    key: 'status_name',
                    label: this.$t('status').toUpper(),
                },
            ],
          showMakePaymentButton: false,
        }
    },
    created() {
        this.getData()
    },
  methods:{
        async getData (){
            const config = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            DocumentRequestService.getStudentDocuments(this.filter.params.student_program_id,config)
                .then(response => {
                    this.documentRequest = response.data.data;
                    this.showMakePaymentButton = this.documentRequest.some(doc => doc.status === 'waiting_payment');
                }).catch(e => {
                this.showErrors(e);
            })
        },
        onlinePayment() {
          let data = {student_program_id: this.filter.params.student_program_id};
          CustomerService.createEpaymentLogin(data)
              .then(response => {
                let data = response.data.data;
                Base.LocalStorage.set('epayment_token', data.token);
                this.setWithExpiry('epayment_redirect_after_payment', window.location.pathname);
                this.$store.commit('epayment/setEpaymentToken', 'Bearer ' + data.token);
                Base.LocalStorage.set('epayment_user', data.customer);
                this.$store.commit('epayment/setEpaymentUser', data.customer)
                this.$router.push('/epayment');
              })
              .catch(e => {
                this.showErrors(e);
              })
        },

    }
}
</script>

<style scoped>

</style>
